var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_283",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H25V25H0V7.62939e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3705 15.7689C20.3727 15.7635 20.3749 15.7582 20.3771 15.7528C20.5788 15.2643 21.0499 14.9414 21.5784 14.9414H22.0703C23.149 14.9414 24.0234 14.067 24.0234 12.9883V12.0117C24.0234 10.9331 23.149 10.0586 22.0703 10.0586H21.5784C21.0499 10.0586 20.5788 9.73569 20.3771 9.24721C20.3749 9.24184 20.3727 9.23647 20.3705 9.23115C20.1676 8.74267 20.2718 8.18086 20.6458 7.80688L20.9936 7.45913C21.7563 6.69638 21.7563 5.45971 20.9936 4.69697L20.303 4.00644C19.5403 3.2437 18.3036 3.2437 17.5409 4.00644L17.1931 4.3542C16.8191 4.72817 16.2573 4.83242 15.7688 4.62954C15.7635 4.62729 15.7582 4.62509 15.7528 4.62285C15.2643 4.42119 14.9414 3.95005 14.9414 3.42158V2.92968C14.9414 1.85102 14.0669 0.97656 12.9883 0.97656H12.0117C10.933 0.97656 10.0586 1.85102 10.0586 2.92968V3.42158C10.0586 3.95005 9.73564 4.42119 9.24717 4.62285C9.2418 4.62509 9.23647 4.62729 9.2311 4.62954C8.74263 4.83242 8.18081 4.72817 7.80683 4.3542L7.45908 4.00644C6.69634 3.2437 5.45967 3.2437 4.69692 4.00644L4.0064 4.69697C3.24365 5.45971 3.24365 6.69638 4.0064 7.45913L4.35415 7.80688C4.72817 8.18086 4.83237 8.74267 4.62949 9.23115C4.62729 9.23647 4.62505 9.24184 4.62285 9.24721C4.42114 9.73569 3.95 10.0586 3.42153 10.0586H2.92969C1.85098 10.0586 0.976562 10.9331 0.976562 12.0117V12.9883C0.976562 14.067 1.85098 14.9414 2.92969 14.9414H3.42153C3.95 14.9414 4.42114 15.2643 4.62285 15.7528C4.62505 15.7582 4.62729 15.7635 4.62949 15.7689",
    stroke: "#163235",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9314 22.2661C20.1447 23.163 19.4624 24.0235 18.5405 24.0235H6.55718C5.63536 24.0235 4.95298 23.163 5.16622 22.2661C5.9586 18.9337 8.97393 16.4551 12.5488 16.4551C14.5268 16.4551 16.3468 17.2138 17.6951 18.4561",
    stroke: "#163235",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64258 12.5C8.64258 10.3426 10.3915 8.59376 12.5488 8.59376C14.7062 8.59376 16.4551 10.3426 16.4551 12.5C16.4551 14.6574 14.7062 16.4063 12.5488 16.4063C10.3915 16.4063 8.64258 14.6574 8.64258 12.5Z",
    stroke: "#163235",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.dd01cb5b08ff256eb944ac2392f5e612.svg";
export { ForwardRef as ReactComponent };